// @flow
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import makeStyles from '@material-ui/core/styles/makeStyles';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Divider from '@material-ui/core/Divider';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import type { MapSource } from '../../../../types';

const useStyles = makeStyles((theme) => ({
    delete: {
        color: theme.palette.error.dark
    }
}));

type Props = $ReadOnly<{
    sourceId: string,
    source: MapSource,

    onPreview: (sourceId: string) => void,
    onDelete: (sourceId: string) => void,
    onActivate: (sourceId: string) => void
}>;

function SourceItemMenu({ sourceId, source, onPreview, onDelete, onActivate }: Props) {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleOpen = (e) => setAnchorEl(e.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const handleAction = (action) => () => {
        handleClose();
        action(sourceId);
    };

    return (
        <React.Fragment>
            <IconButton
                aria-label="more"
                aria-controls="long-menu"
                aria-haspopup="true"
                onClick={handleOpen}
            >
                <MoreVertIcon />
            </IconButton>
            <Menu
                id="long-menu"
                anchorEl={anchorEl}
                keepMounted
                open={open}
                onClose={handleClose}
            >
                <MenuItem onClick={handleAction(onPreview)}>
                    <FormattedMessage
                        id="options.map.menu.preview"
                        defaultMessage="Preview"
                    />
                </MenuItem>
                <MenuItem className={classes.delete} disabled={source.internal} onClick={handleAction(onDelete)}>
                    <FormattedMessage
                        id="options.map.menu.delete"
                        defaultMessage="Delete"
                    />
                </MenuItem>

                <Divider />

                <MenuItem onClick={handleAction(onActivate)}>
                    <FormattedMessage
                        id="options.map.menu.activate"
                        defaultMessage="Activate"
                    />
                </MenuItem>
            </Menu>
        </React.Fragment>
    );
}

export default SourceItemMenu;